module.exports = __webpack_public_path__ + "static/media/favicon1.f73af58d.jpg";